// Same page/data-fetching as invite-landing.js, only reachable at a
// different path - this one is deliberately absent from
// static/.well-known/apple-app-site-association's universal link
// components, so it always opens the web page instead of deep-linking into
// the native app.
export { component, thunk } from './invite-landing';

export const path = '/invite-glp-won/:inviteToken';
